import * as React from 'react';

import { Button, TextInput } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';
import type { DirectoryEntity } from 'af-components/DocumentsAttachmentsTree/types';
import SubmitButton from 'af-components/SubmitButton';

import styles from './styles.module.scss';

interface Props {
	showModal: boolean;
	parent: Nullable<DirectoryEntity>;
	createDirectory: (parent: DirectoryEntity, name: string) => void;
	closeModal: () => void;
}

const CreateNewDirectoryScheduleBoardModal = React.memo((props: Props) => {
	const { createDirectory, parent, closeModal, showModal } = props;

	const [name, setName] = React.useState('');

	const baseClassName = 'modal';
	const headerClassName = `${baseClassName}__big-header__thin`;
	const bodyClassName = `${baseClassName}__body`;

	React.useEffect(() => {
		if (!showModal) {
			setName('');
		}
	}, [showModal]);

	const isDuplicateName = React.useMemo(() => {
		return parent?.directories.some((_dir) => _dir.name === name);
	}, [name, parent?.directories]);

	const handleNameChange = React.useCallback((value: string) => {
		setName(value);
	}, []);

	const createChildDirectory = React.useCallback(() => {
		if (!parent || !name) {
			return;
		}
		createDirectory(parent, name);
		closeModal();
	}, [closeModal, createDirectory, name, parent]);

	return (
		<>
			<CustomModal
				className={styles[baseClassName]}
				closeModal={closeModal}
				modalStyle="info"
				showModal={showModal}
				size="md"
			>
				<CustomModal.Header className={styles[headerClassName]}>
					<span>New Folder</span>
				</CustomModal.Header>
				<CustomModal.Body className={styles[bodyClassName]}>
					<TextInput
						error={isDuplicateName ? 'A Directory with that name already exists.' : undefined}
						isRequired={true}
						label="Folder name"
						onChange={handleNameChange}
						placeholder="New folder"
						type="text"
						value={name}
					/>
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Cancel"
						onClick={closeModal}
						style="secondary"
					/>
					<SubmitButton disabled={isDuplicateName} label="Save" onClick={createChildDirectory} />
				</CustomModal.Footer>
			</CustomModal>
		</>
	);
});

export default CreateNewDirectoryScheduleBoardModal;
